export default "__VITE_ASSET__hMNTIhgg__"